import request from 'services/request';

export const getSchedulesApi = async (params) =>
  request({
    url: 'schedules',
    method: 'GET',
    params,
  });
